import {emotionStyled} from '@packages/utilities/styled';
import {Stack} from '../Stack';

export const CheckboxGroupView = emotionStyled(Stack)(
  {},
  {
    componentName: 'CheckboxGroup',
  }
);
